import moment from "moment";
import { UserForm } from "../pages/Users/SubComponents/UserCard";
import { Absence } from "../types/Absence";
import { Timesheet, PersonalTimesheet } from "../types/Timesheet";
import { User } from "../types/User";
import { TimesheetAuditLog, UserChangeLog } from "../types/UserChangeLog";
import agent from "./agent";

export interface ActivityReturnType {
  timesheets: Timesheet[];
  absences: Absence[];
  personalTimesheets: PersonalTimesheet[];
}

const userApi = {
  searchUsers: async (query: string) => agent.get<User[]>("/users/search", { params: { query } }),
  adminEdit: async (id: string, body: UserForm) => agent.put(`/users/${id}`, body),
  getTimesheetLogs: (id: string, version: "v1" | "v2") =>
    agent.get<{ logs: TimesheetAuditLog[] }>(`/users/${id}/timesheet-balance-log?version=${version}`),
  getChangeLog: (id: string) => agent.get<{ logs: UserChangeLog[] }>(`/users/${id}/change-log`),
  getActivity: (id: string, activeDate: Date) =>
    agent.get<ActivityReturnType>(`/users/${id}/activity`, {
      params: { activeDate: moment(activeDate).format("YYYY-MM-DD") },
    }),
  getBalance: (id: string) => agent.get<{ balance: number }>(`/users/${id}/timesheet-balance`),
  recomputeDays: (id: string, dates: string[]) =>
    agent.post<{ balance: number }>(`/users/${id}/timesheet-balance`, {
      dates,
    }),
  deleteOvertimeData: (id: string) => agent.delete(`/users/${id}/overtime-data`),
};

export default userApi;
